import { errorCodeMapping } from "@/apps/merchant3/shared-helpers/errorCodeMappings";

export const getAPIErrorMessage = (
  // eslint-disable-next-line
  data: any,
  t: (key: string) => string,
  defaultMessage?: string | null
): string => {
  const fallbackMessageKey = "ERROR_SOMETHING_GOES_WRONG";
  let message: string = defaultMessage || t(fallbackMessageKey);
  if (data?.errorCode) {
    const errorCode = data.errorCode;
    const errorMessage = data.message ?? "";
    let parameters = "";
    const errorMessageKey = errorCodeMapping[errorCode] ?? fallbackMessageKey;
    if (errorCode == 10077) {
      if (errorMessage) {
        parameters = errorMessage.substring(errorMessage.indexOf(":") + 1);
        parameters = parameters ? parameters + "." : "";
      }
      message = t(errorMessageKey) + " " + parameters;
    } else {
      message = t(errorMessageKey);
    }

    // Append the error code to get better support from devs.
    if (errorCode !== 10056) {
      message += t("ERROR_CODE") + errorCode.toString();
    }
  }
  return message;
};
